import { render } from "./PanelistDashboardPage.vue?vue&type=template&id=123cc67f&ts=true"
import script from "./PanelistDashboardPage.vue?vue&type=script&lang=ts"
export * from "./PanelistDashboardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__